import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .BoProptradingTable {
    .ReactDataTable__wrapper {
      @include respond-to(xl) {
        overflow-x: auto;
      }
    }

    .ReactDataTable__thead-row {
      gap: 8px;
    }

    .ReactDataTable__tbody-row {
      gap: 8px;
      height: 70px;
      cursor: pointer;
    }

    .ReactDataTable__thead-cell,
    .ReactDataTable__tbody-cell {
      width: auto !important;
      white-space: normal;
      font-size: 13px;
      line-height: 20px;
    }

    .ResponsiveTable__row {
      .ResponsiveTable__preview-main {
        height: 30px !important;
      }

      .ResponsiveTable__preview-description {
        display: flex;
        align-items: center;
        padding-right: 7%;

        .ResponsiveTable__row-item {
          &:nth-child(2) {
            .DateCell__time {
              display: none !important;
            }
          }
        }
      }

      .ResponsiveTable__row-item {
        display: flex;
        align-items: center;

        &:nth-child(1) {
          flex: 5;
          font-size: rem(14px);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          min-width: 0;

          span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        &:nth-child(2) {
          flex: 5;
          justify-content: center;
          font-size: rem(12px);
        }
      }
    }
  }
`;

export { staticStyles };
